import * as info from "info";
import { Prefs } from "~/alias/prefs";
import { getUserId } from "~/id/background";
import { License } from "~/picreplacement/check";
import * as utils from "~/utilities/background";
import { port } from "../../../adblockplusui/adblockpluschrome/lib/messaging/port";
import { getBlockCount } from "./block-count";
export async function getFutureStartInfo() {
    await Prefs.untilLoaded;
    return {
        logger: utils,
        info: {
            async getId() {
                return await getUserId();
            },
            getAppName() {
                return info.baseName;
            },
            getAppVersion() {
                return info.addonVersion;
            },
            getBrowserName() {
                return info.application;
            },
            getBrowserVersion() {
                return info.applicationVersion;
            },
        },
        getBlockCount,
        async isOptedOut() {
            return Prefs.get("data_collection_opt_out") === true;
        },
        getDefaultOrigin() {
            return Prefs.get("ipm:default_origin");
        },
        getSafeOrigins() {
            return Prefs.get("ipm:safe_origins");
        },
        getDismissedIpmIds() {
            return Prefs.get("ipm:dismissed_ipm_ids");
        },
        setDismissedIpmIds(ipmIds) {
            void Prefs.set("ipm:dismissed_ipm_ids", ipmIds);
        },
        addMessageListener(name, listener) {
            port.on(name, listener);
        },
        removeMessageListener(name, listener) {
            port.off(name, listener);
        },
        getLastSyncId() {
            return Prefs.get("ipm:last_sync_id");
        },
        setLastSyncId(syncId) {
            void Prefs.set("ipm:last_sync_id", syncId);
        },
    };
}
export const legacyStartInfo = {
    prefs: Prefs,
    logger: utils,
    licensing: {
        async isLicenseValid() {
            await License.ready();
            return await License.isActiveLicense();
        },
    },
    info: {
        async getId() {
            return await getUserId();
        },
        getAppName() {
            return info.baseName;
        },
        getAppVersion() {
            return info.addonVersion;
        },
        getBrowserName() {
            return info.application;
        },
        getBrowserVersion() {
            return info.applicationVersion;
        },
    },
    getBlockCount,
    async isOptedOut() {
        await Prefs.untilLoaded;
        return Prefs.get("data_collection_opt_out") === true;
    },
    addMessageListener(name, listener) {
        port.on(name, listener);
    },
    removeMessageListener(name, listener) {
        port.off(name, listener);
    },
};
